// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-leftNav {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: var(--color-navLeft-background);
  border-right: 1px solid var(--color-navLeft-border);
  padding: 24px 0 14px;
  width: 60px;
  justify-content: space-between;
}
.comp-leftNav .leftNav-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.comp-leftNav .leftNav-container button {
  cursor: pointer;
  background: transparent;
  border: 0;
  font-size: 28px;
  display: flex;
  justify-content: center;
  height: 42px;
  align-items: center;
  width: 100%;
}
.comp-leftNav .leftNav-container button svg {
  color: var(--color-navLeft-button-bg);
}
.comp-leftNav .leftNav-container button:hover svg {
  color: var(--color-navLeft-button-active);
}
.comp-leftNav .leftNav-container .btn-active {
  border-left: 2px solid var(--color-featureColor);
  border-radius: 0;
}
.comp-leftNav .leftNav-container .btn-active svg {
  color: var(--color-navLeft-button-active);
}
.comp-leftNav .leftNav-containerBottom {
  margin-bottom: -8px;
  align-items: center;
}
.comp-leftNav .leftNav-containerBottom .containerBottom-topLine {
  background-color: var(--color-navLeft-topLine-bg);
  display: flex;
  height: 1px;
  width: 52px;
}

.unknown-identity {
  color: var(--color-navLeft-button-active);
  font-family: Ubuntu-L, sans-serif;
  font-size: 10px;
  display: flex;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
}

@media (max-width: 599px) {
  .comp-leftNav {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/leftNav/leftNav.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iDAAA;EACA,mDAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AADJ;AAGI;EACE,eAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AADN;AAGM;EACE,qCAAA;AADR;AAMM;EACE,yCAAA;AAJR;AAQI;EACE,gDAAA;EACA,gBAAA;AANN;AAQM;EACE,yCAAA;AANR;AAWE;EACE,mBAAA;EACA,mBAAA;AATJ;AAWI;EACE,iDAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AATN;;AAcA;EACE,yCAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;AAXF;;ACxDI;EDuEF;IACE,aAAA;EAXF;AACF","sourcesContent":["@import '../../theme/responsiv.scss';\n\n.comp-leftNav {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  background-color: var(--color-navLeft-background);\n  border-right: 1px solid var(--color-navLeft-border);\n  padding: 24px 0 14px;\n  width: 60px;\n  justify-content: space-between;\n\n  .leftNav-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n\n    button {\n      cursor: pointer;\n      background: transparent;\n      border: 0;\n      font-size: 28px;\n      display: flex;\n      justify-content: center;\n      height: 42px;\n      align-items: center;\n      width: 100%;\n\n      svg {\n        color: var(--color-navLeft-button-bg);\n      }\n    }\n  \n    button:hover {\n      svg {\n        color: var(--color-navLeft-button-active);\n      }\n    }\n  \n    .btn-active {\n      border-left: 2px solid var(--color-featureColor);\n      border-radius: 0;\n\n      svg {\n        color: var(--color-navLeft-button-active);\n      }\n    }\n  }\n\n  .leftNav-containerBottom {\n    margin-bottom: -8px;\n    align-items: center;\n\n    .containerBottom-topLine {\n      background-color: var(--color-navLeft-topLine-bg);\n      display: flex;\n      height: 1px;\n      width: 52px;\n    }\n  }\n}\n\n.unknown-identity {\n  color: var(--color-navLeft-button-active);\n  font-family: Ubuntu-L, sans-serif;\n  font-size: 10px;\n  display: flex;\n  justify-content: center;\n  user-select: none;\n}\n\n@include appSize(phone-only) {    \n  .comp-leftNav  {\n    display: none;\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
